import { styled } from '@mui/material/styles'
import { Backdrop } from '@mui/material'

export const StyledBackdrop = styled(Backdrop)(() => ({
  background: 'rgba(217, 217, 217, 0.16)',
  backdropFilter: 'blur(2px)',
  mixBlendMode: 'normal',
}))
